module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "controller-list"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('title.controllers')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.emergency
    }
  }, [_vm._v(_vm._s(_vm.$t('button.emergency')))]), _vm._v(" "), _c('data-table', {
    attrs: {
      "model": "controllers",
      "columns": ['name', 'ip', 'rssi', 'status'],
      "operations": _vm.operations,
      "disable-loading-indicator": ""
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('title.activate-controller'),
      "visible": _vm.showActivateDialog
    }
  }, [_c('p', [_vm._v("\n      " + _vm._s(_vm.$t('question.controllerCertificate')) + "\n    ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.controllerToActivate.readeableHash))])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.activateController
    }
  }, [_vm._v(_vm._s(_vm.$t('button.accept')))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.cancelActivation
    }
  }, [_vm._v(_vm._s(_vm.$t('button.cancel')))])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('title.remove'),
      "visible": !!_vm.modelToDelete,
      "width": "30%",
      "before-close": function () {
        _vm.modelToDelete = null
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('remove.message')))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.modelToDelete = null
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm._deleteOperation
    }
  }, [_vm._v(_vm._s(_vm.$t('button.confirm')))])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-04dce0e0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/controller/ControllerList.vue
// module id = 965
// module chunks = 2